export const loginType = {
    unknown: 0,
    internalAuth: 1,
    AAD: 2
}